import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OrderPrintService {

  printResource: any;
  constructor() { }

  setPrintResource(resource: any) {
    this.printResource = resource
  }

  getPrintResource() {
    return this.printResource;
  }

}
